// extracted by mini-css-extract-plugin
module.exports = {"appsPlaceholder":"WelcomeMessage_appsPlaceholder__1QSL3","projectInfo":"WelcomeMessage_projectInfo__3GjPy","mosaic_normal":"WelcomeMessage_mosaic_normal__2XwBY"};